import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';
import { FontWeight, QuicksandBold } from 'components/Text/Text';

const propTypes = {
  isActive: PropTypes.bool,
  newBorder: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
  newBorder: false
}

//modal

const DialogSelect = styled.div`

  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.PINK};
  border: 0px;
  border-radius: 5px;
  font-weight: ${QuicksandBold};
  font-size: 14px;
  font-family: 'Quicksand';
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: ${QuicksandBold};
  font-size: 14px;
  font-family: 'Quicksand';
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.PURPLE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
`;

const CustomField = styled.div`
  div{
    min-height: auto;
    margin-bottom: 0px;
    width: 100%;
  }
  .is-approved{
    span{
      color: ${Colors.GRAY[0]};
    }
  }
  .is-disabled{
    span{
      color: ${Colors.GRAY[3]}
    }
  }
`;

//modal

const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;


const ButtonContent = styled.div`
    display:flex;
    flex-direction:auto;
    justify-content:space-evenly;
`;

const CalendarContainer = styled.div`
z-index: 55;
top: 60px;
right: 24px;

position: absolute;
`;

const TextArea = styled.textarea`
width: 102%;
height: 70px;
border: 1px solid #888;
border-radius: 8px;
margin-left: -12px;
margin-top: 0px;
padding: 10px;
margin-bottom: 0px;
resize: none;
cursor: auto;
  ${QuicksandBold};  
  color: ${Colors.GRAY[0]};
  transition: box-shadow 0.15s ease;

  outline: none;
  :focus {
    background: ${Colors.GRAY[5]};
    box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 0 3px ${Colors.SECONDARY};
  }
`;

const Fieldset = styled.fieldset`
  border: solid;
  border-color: ${Colors.GRAY[4]};
  border-width: 0px 0px 0px 0px;;
  padding: 0px 10px 20px 0px;
  & + Fieldset {
    border-width: 2px 0px 0px 0px;
  }
`;

const Heading = styled.h2`
  color: ${Colors.GRAY[6]};
  padding-left: 10px;
`;

const BackToList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${Colors.WHITE};

  margin-bottom: 25px;
  background: ${Colors.WHITE};
  border-radius: 8px;
  border: 1px 1px 1px 1px solid;
  box-sizing: border-box;
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
`;

export {
  BackToList,
  Heading,
  Content,
  ButtonContent,
  ButtonContainer,
  TextArea,
  CalendarContainer,
  DialogCancel,
  DialogSelect,
  DialogConfirm,
  DialogRejected,
  CustomField,
  Fieldset
};